<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {

	components: {
	  Layout
	},
   data() {
      return {           
         errors: {},
         script: null,
         style: null,
      };
   },

   created() {
          this.style = document.createElement('link')
          this.style.setAttribute('rel', 'stylesheet')
          this.style.setAttribute('href', '/design/terms-of-use.css')
          document.head.appendChild(this.style)
    },

    beforeDestroy() {
        document.head.removeChild(this.style);
    },

	mounted() {
      this.updatePayment();
	},


   methods: {
      updatePayment() {
         //alert(this.$route.query.tap_id);

         if(this.$route.query.tap_id) {

            var config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
               },
            };

            let url = "Checkout/updatePaymentStatus?tap_id=" + this.$route.query.tap_id;

            this.$axios
            .get(url, config)
            .then((response) => {
               if (response.data.status == true) {
                  console.log(response.data.data);
                     this.$router.push({ name: 'order-success'});

               } else{
                  this.$swal("", response.data.message, "Failed");
                  this.$router.push({ name: 'cart'});
                  this.$router.push({ name: 'checkout', params:{address_id: response.data.data.address_id}});
               } 
                    
            })
            .catch((error) => {
               console.log(error);
               if (error.response) {

                  this.$swal("", "Something went wrong. Please try agian", "error");
                  console.log(error.response);
                  if(error.response.data) {
                     this.$router.push({ name: 'checkout', params:{address_id: error.response.data.address_id}});
                  } else {
                     this.$router.push({ name: 'cart'});
                  }
               } else {
                  this.$swal("", "Something went wrong. Please try agian", "error");
                  this.$router.push({ name: 'cart'});
               }
               
            })
            .finally(() => (this.loading = false));
         }
      },
   }  
}
</script>
<template>
    <layout>
      <div class="container-sm py-5">
         <div class="loading py-5">
            <div class="text-center">
               <img src="/design/sigofood-images/loading-gif.gif" alt="loading">
               <p>Loading...</p>
            </div>
         </div>
      </div>
    </layout>
</template>